<script>
import api from '@/helpers/api'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'settings.general',
  data: () => ({
    isLoading: false,
    options: {}
  }),
  mounted () {
    this.onInit()
  },
  methods: {
    async onInit () {
      this.isLoading = true
      let app = await api.appPreferences.fetch({ key: 'app' })
      if (!app) app = await api.appPreferences.create({ key: 'app' })

      this.options = { ...app.options }
      this.isLoading = false
    },
    async onSaveOption (key, value) {
      this.isLoading = true
      let item = await api.appPreferences.updateOption('app', key, value)
      this.options = { ...item }
      this.$v.$reset()
      this.isLoading = false
    }
  },
  validations: {
    options: {
      vat_rates: {
        required
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">General Settings</h4>

      <div class="d-flex flex-column mt-3">
        <b-form-group
          label="VAT Percentages"
          label-for="vat_rates"
          class="mb-2"
        >
          <b-input-group>
            <g-number-tag-input
              v-model="$v.options.vat_rates.$model"
              :min="0"
              :max="100"
              placeholder="Add a Percentage and press enter"
              tagSuffix="%"
              size="sm"
            />
            <b-input-group-append v-if="$v.options.vat_rates.$dirty">
              <b-btn
                variant="primary"
                v-on:click="onSaveOption('vat_rates', options.vat_rates)"
                :disabled="!$v.options.vat_rates.$dirty"
              >
                <i class="bx bx-save mr-1"></i>Save Changes
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <pre v-show="false">{{ $v.options.vat_rates }}</pre>
    </b-card>
  </g-overlay>
</template>
